import { navigateTo } from 'mfa'

// Only same-origin relative paths are followed. A leading "/" alone would
// still allow protocol-relative URLs like "//evil.com" (browsers treat
// those as absolute), so that's explicitly rejected too.
export const isSameOriginPath = (path) =>
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')

export async function apiRequest(apiFn, ...args) {
  try {
    return await apiFn(...args)
  } catch (error) {
    if (isSameOriginPath(error.redirect_uri)) {
      navigateTo(error.redirect_uri)
      return
    }
    throw error
  }
}
